import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("users");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async newUser({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("users", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async saveUser({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`users`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async resetUserTempPassword({ dispatch }, payload) {
      api.post(`users/resetTempPassword`, payload);
    },
    async userEmailChangeRequest({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`user/emailChangeRequest`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success"
            };
          } else {
            returnData = {
              Result: "Failed"
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadCurrentUserData");
      return returnData;
    },
    async userEmailVerification({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`user/verifyUserEmail`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success"
            };
          } else {
            returnData = {
              Result: "Failed"
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadCurrentUserData");

      return returnData;
    },
    async resetPasswordChangeRequest({ dispatch }, payload) {
      let returnData = {};

      await api
        .post(`user/passwordChangeRequest`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success"
            };
          } else {
            returnData = {
              Result: "Failed"
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async saveProfile({ dispatch }, payload) {
      let returnData = {};

      await api
        .put(`user/saveProfile`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    }
  }
};
